import { EXERCISE_LOG_SUMMARY_KEY } from '../constants'
import oneRepMaxExerciseLogSummaryValidatorUtil from './one-rep-max'

const exerciseLogSummaryValidator = {
  [EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX]: oneRepMaxExerciseLogSummaryValidatorUtil
}

export default exerciseLogSummaryValidator
